const Footer = () => {

  const footerLinks = {
    'Vehicle Lending': {
      mainLink: 'https://www.udc.co.nz/car-loans/index',
      links: [
        { 'Car Loans': 'https://www.udc.co.nz/car-loans/index' },
        { 'Electric Vehicle Loans': 'https://www.udc.co.nz/car-loans/EV' },
        { 'Boat Loans': 'https://www.udc.co.nz/car-loans/boat-loans' },
        { 'Apply Now': 'https://www.udc.co.nz/car-loans/apply' },
        { 'FAQs': 'https://www.udc.co.nz/car-loans/faqs' },
        { 'Customer Service': 'https://www.udc.co.nz/car-loans/customer-service/index' },
        { 'Fees, Rates and Documentation': 'https://www.udc.co.nz/car-loans/fees-rates-documentation' },
        { 'Find a Dealer': 'https://www.udc.co.nz/car-loans/find-dealer/index.html' }
      ],
      subLinks: []
    },
    'Asset Finance': {
      mainLink: 'https://www.udc.co.nz/asset-finance/index',
      links: [
        { 'Fleet Finance': 'https://www.udc.co.nz/asset-finance/fleet-finance' },
        { 'Equipment Finance': 'https://www.udc.co.nz/asset-finance/equipment-finance' },
        { 'Owner Driver Finance': 'https://www.udc.co.nz/asset-finance/commercial-vehicle-finance' },
        { 'Clean Tech Finance': 'https://www.udc.co.nz/asset-finance/clean-tech-finance' },
        { 'Find a Specialist': 'https://www.udc.co.nz/asset-finance/find-specialist/index.html' },
        { 'FAQs': 'https://www.udc.co.nz/asset-finance/faqs' },
        { 'Customer Service': 'https://www.udc.co.nz/asset-finance/customer-service' }
      ],
      subLinks: []
    },
    'About us': {
      mainLink: 'https://www.udc.co.nz/about-us/index',
      links: [
        { 'Contact Us': 'https://www.udc.co.nz/contact-us' },
        { 'UDC News': 'https://www.udc.co.nz/about-us/udc-news' },
        { 'Our Team': 'https://www.udc.co.nz/about-us/udc-team' },
        { 'Dealer Finance': 'https://www.udc.co.nz/about-us/dealer-finance' },
        { 'Careers': 'https://udcfinance.csod.com/ux/ats/careersite/5/home?c=udcfinance' }
      ],
      subLinks: [
        { 'UDC Live': 'https://nz.udclive.co.nz/external/login' },
        { 'MyUDC': 'https://my.udc.co.nz/?_ga=2.103920263.685964961.1658281333-1642631903.1658281333' }
      ]
    }
  }
  
  const footerLinnksBottom = [
      { 'Home': 'https://www.udc.co.nz/' },
      { 'Calculators': 'https://www.udc.co.nz/calculators' },
      { 'Website Security & Privacy': 'https://www.udc.co.nz/website-security-privacy' },
      { 'Disclosure Statement': 'https://www.udc.co.nz/about-us/index#QFE-Disclosure-Statement' },
      { 'Credit Rating': 'https://www.udc.co.nz/credit-rating' },
      { 'Sitemap': 'https://www.udc.co.nz/site-map' },
  ]

  return (
    <footer className='bg-[var(--theme-bg)] text-sm'>
    <div className='bg-white py-8 px-8 lg:px-10 text-[var(--theme-text-alt)]'>
      <div className='max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-8'>
        {Object.entries(footerLinks).map(([title, { mainLink, links, subLinks }], colIndex) => (
          <div key={colIndex}>
            <h3 className='mb-3'>
              <a href={mainLink} className='text-[var(--brand-1)] [@media(hover:hover)]:hover:underline'>{title}</a>
            </h3>
            <ul className='space-y-2.5 md:space-y-1.5'>
              {links.map((link, index) => (
                <li key={index}>
                  <a className='[@media(hover:hover)]:hover:underline' href={Object.values(link)[0]}>{Object.keys(link)[0]}</a>
                </li>
              ))}
            </ul>
            {subLinks.length > 0 && (
              <ul className='space-y-2.5 md:space-y-1.5 mt-8'>
                {subLinks.map((link, index) => (
                  <li key={index}>
                    <a className='font-bold [@media(hover:hover)]:hover:underline' href={Object.values(link)[0]}>{Object.keys(link)[0]}</a>
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>
    </div>
    <div role='contentinfo' className='pt-8 pb-6 px-8 lg:px-10 text-black'>
      <div className='space-y-6 max-w-6xl mx-auto'>
        <ul className='flex flex-col md:flex-row w-full gap-6 flex-wrap justify-evenyly'>
          {footerLinnksBottom.map((link, index) => (
            <li className='grow' key={index}>
              <a href={Object.values(link)[0]} className='[@media(hover:hover)]:hover:underline'>{Object.keys(link)[0]}</a>
            </li>
          ))}
        </ul>
        <p className='text-base'>&copy; UDC Finance Limited. All rights reserved.</p>
      </div>
    </div>
    </footer>
  )
}

export { Footer }
